import {useEffect, useRef, useState} from 'react';

export default function useInterval(callback, delay, limit) {
    const [count, setCount] = useState(1);
    const intervalRef = useRef();
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        if (count <= limit || !limit) {
            intervalRef.current = window.setInterval(() => {
                setCount(c => c + 1);
                callbackRef.current(count, setCount);
            }, delay);
            return () => {
                window.clearInterval(intervalRef.current);
            }
        }
    }, [delay, count]);

    return intervalRef;
}